/*
  Mije Seoul — overlays behaviour (pt2 Screen 10): region selector,
  newsletter success toast, notify-modal opt-in tag merge.

  Region persistence: mije.region.v1 in localStorage. Countries enabled in
  Shopify Markets submit the native localization form; the others persist
  locally only (SGD-only reality — the selector is a country selector).
  Toast trigger: /contact customer posts can't carry a marker through the
  redirect, so the submitting form writes a sessionStorage pending flag
  ('newsletter' | 'notify') and the landing page reads customer_posted=true
  plus the flag. mije-wishlist.js checks the same flag before showing the
  notify modal's success state.
*/

(function () {
  'use strict';

  var REGION_KEY = 'mije.region.v1';
  var PENDING_KEY = 'mije.posted.pending';

  /* --------------------------------------------------------------- helpers */

  function trapDialog(modal, closeFn) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeFn();
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = modal.querySelectorAll('button, [href], input, select, textarea');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* -------------------------------------------------------- region selector */

  var regionModal = document.querySelector('[data-region-modal]');
  var regionTrigger = null;

  function openRegion() {
    if (!regionModal) return;
    regionModal.hidden = false;
    var checked = regionModal.querySelector('[data-region-radio]:checked') || regionModal.querySelector('[data-region-radio]');
    if (checked) checked.closest('label').focus ? checked.closest('label').focus() : checked.focus();
    updateRegionButton();
  }

  function closeRegion() {
    if (!regionModal || regionModal.hidden) return;
    regionModal.hidden = true;
    if (regionTrigger) regionTrigger.focus();
  }

  function updateRegionButton() {
    var checked = regionModal.querySelector('[data-region-radio]:checked');
    var btn = regionModal.querySelector('[data-region-submit]');
    if (checked && btn) {
      var currency = (checked.dataset.currency || '').split(' ')[0] || 'SGD';
      btn.textContent = 'Shop in ' + currency;
    }
  }

  if (regionModal) {
    document.querySelectorAll('[data-region-open]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        regionTrigger = t;
        openRegion();
      });
    });
    regionModal.querySelector('[data-region-close]').addEventListener('click', closeRegion);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeRegion();
    });
    trapDialog(regionModal, closeRegion);
    regionModal.addEventListener('change', updateRegionButton);

    regionModal.querySelector('form').addEventListener('submit', function (e) {
      var checked = regionModal.querySelector('[data-region-radio]:checked');
      if (!checked) return;
      try {
        localStorage.setItem(REGION_KEY, checked.value);
      } catch (err) { /* private mode */ }
      if (checked.dataset.available !== 'true') {
        /* country not enabled in Markets — persist locally, no form round-trip */
        e.preventDefault();
        closeRegion();
      }
    });
  }

  /* --------------------------- posted-flag plumbing (newsletter vs notify) */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('action') === null || form.action.indexOf('/contact') === -1) return;
    var typeInput = form.querySelector('input[name="form_type"]');
    if (!typeInput || typeInput.value !== 'customer') return;
    var tags = form.querySelector('input[name="contact[tags]"]');
    var kind = tags && tags.value.indexOf('notify-restock') !== -1 ? 'notify' : 'newsletter';
    try {
      sessionStorage.setItem(PENDING_KEY, kind);
    } catch (err) { /* private mode */ }
  });

  /* --------------------------------------------- notify opt-in tag merge */

  var optin = document.querySelector('[data-notify-optin]');
  if (optin) {
    optin.addEventListener('change', function () {
      var tags = document.querySelector('[data-notify-tags]');
      if (!tags) return;
      var base = tags.value.replace(/,newsletter$/, '');
      tags.value = optin.checked ? base + ',newsletter' : base;
    });
  }

  /* ------------------------------------------------------------------ toasts */

  var stack = document.querySelector('[data-toast-stack]');

  function showToast(name, opts) {
    if (!stack) return;
    var tpl = document.querySelector('[data-toast-template="' + name + '"]');
    if (!tpl) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    stack.appendChild(node);
    while (stack.children.length > 3) stack.removeChild(stack.firstElementChild);
    var dismiss = node.querySelector('[data-toast-dismiss]');
    var remove = function () {
      if (node.parentNode) node.parentNode.removeChild(node);
    };
    if (dismiss) dismiss.addEventListener('click', remove);
    if (!opts || !opts.persist) setTimeout(remove, 5000);
  }
  window.MijeToast = showToast;

  /* newsletter success lands back with ?customer_posted=true */
  var pending = null;
  try {
    pending = sessionStorage.getItem(PENDING_KEY);
  } catch (err) { /* private mode */ }
  if (new URLSearchParams(window.location.search).get('customer_posted') === 'true' && pending === 'newsletter') {
    try {
      sessionStorage.removeItem(PENDING_KEY);
    } catch (err) { /* private mode */ }
    showToast('newsletter');
  }
})();
